import * as yup from "yup";

const stockSalesReturn = yup.object().shape({
	invoiceNo: yup.string().required("Invoice number is requried."),
	productId: yup.string().required("Choose a product."),
	quantity: yup.number().required("Please, specify quantity."),
});

export default stockSalesReturn;
